import React from 'react';
import {connect} from 'react-redux';
import {reduxForm} from 'redux-form';
import {defineMessages, FormattedMessage, FormattedHTMLMessage} from 'react-intl';

import {stripProps} from 'shared/stripCorrectProps';

import * as JoinPromoTypes from 'constants/JoinPromoType';

const fields = [
    'phone'
];

function phoneValidation(values) {
    let errors = {};

    if (!values.phone || !values.phone.length) {
        errors.phone = 'Поле обязательно для заполнения';
    }

    return errors;
}

const messages = defineMessages({
    title: {
        id: 'phone_confirm.title',
        defaultMessage: 'Подтверждение номера телефона'
    },
    phone: {
        id: 'phone_confirm.phone',
        defaultMessage: 'Мобильный телефон'
    },
    smsText: {
        id: 'phone_confirm.sms_text',
        defaultMessage: 'На данный телефон будет выслано SMS с кодом подтверждения'
    },
    confirmButton: {
        id: 'phone_confirm.confirm_button',
        defaultMessage: 'Подтвердить'
    },
    denial: {
        id: 'phone_confirm.denial',
        defaultMessage: 'Не желаю участвовать в акции, просто зарегистрируйте мне счет'
    },
    conditions: {
        id: 'phone_confirm.conditions',
        defaultMessage: 'Для участия в акциях необходимо подтвердить номер мобильного телефона'
    },
    confirmationError: {
        id: 'phone_confirm.errors.confirmation_fail',
        defaultMessage: 'Ошибка при подтверждении'
    },
    phoneTakenError: {
        id: 'phone_confirm.errors.phone_taken',
        defaultMessage: 'Телефон уже используется'
    },
    site146Proposal: {
        id: 'special_offers.site146_proposal',
        defaultMessage: "Указанный Вами промо-код позволяет принять участие в акции «Вступительный бонус – 1000 тенге!».<br />" +
        "Для начисления бонуса необходимо подтвердить номер мобильного телефона"
    },
    phone_hint: {
        id: 'phone_confirm.phone_hint',
        defaultMessage: 'Используйте международный префикс, например: 7 777 123 45 67'
    }
});

class PhoneInput extends React.Component {
    static propTypes = {
        fields: React.PropTypes.object.isRequired,
        handleSubmit: React.PropTypes.func.isRequired,
        submitting: React.PropTypes.bool.isRequired,
        languageId: React.PropTypes.number.isRequired,
        gamblerId: React.PropTypes.number.isRequired,
        joinPromoType: React.PropTypes.any,
        phone: React.PropTypes.string,
        phoneConfirming: React.PropTypes.bool.isRequired,
        phoneConfirmationError: React.PropTypes.any,
        createPhoneConfirmation: React.PropTypes.func.isRequired,
        denyConfirmationCallback: React.PropTypes.func.isRequired
    };

    constructor(props) {
        super(props);
        this._onSubmit = this._onSubmit.bind(this);
    }

    _onSubmit(values) {
        const gamblerId = this.props.gamblerId;

        this.props.createPhoneConfirmation(
            {
                gamblerId,
                oldPhone: this.props.fields.phone.initialValue,
                newPhone: values.phone
            });
    }

    render() {
        const {fields: {phone}, joinPromoType, phoneConfirming, phoneConfirmationError, handleSubmit} = this.props;
        const denialLinkStyle = {color:'#186b38'};

        let message = messages.confirmationError;
        if (phoneConfirmationError === -1) {
            message = messages.phoneTakenError;
        }

        let specialOfferMessage = messages.conditions;
        if (joinPromoType === JoinPromoTypes.SITE146) {
            specialOfferMessage = messages.site146Proposal;
        }

        const submitHandler = this._onSubmit;

        return (
            <div className="modal--dialog">
                <div className="modal--header">
                    <div className="header-inner--logotype__link"></div>
                    <div className="header-inner__title">
                        <FormattedMessage {...messages.title}/>
                    </div>
                </div>
                <div className="modal--content">
                    <div className="modal--content__wrapper">
                        <form className="login--form form" onSubmit={handleSubmit(submitHandler)} autoComplete="off">
                            <p className="plain-text__paragraph">
                                <FormattedHTMLMessage {...specialOfferMessage} />
                            </p>
                            {phoneConfirmationError &&
                            <div className="error-message">
                                <FormattedMessage {...message} />
                            </div>}
                            <div className="login--form__row form__row">
                                <label className="login--form__label form__label">
                                    <FormattedMessage {...messages.phone} />
                                </label>
                                <input className="login--form__control form__control" {...stripProps(phone)}/>
                                <div className="hint">
                                    <FormattedMessage {...messages.phone_hint} />
                                </div>
                            </div>
                            <div className="login--form__row form__row">
                                <button disabled={phoneConfirming}
                                        type="submit"
                                        className="login--form__btn login--form__btn__js form__btn"
                                        onClick={handleSubmit(submitHandler)}>
                                    <FormattedMessage {...messages.confirmButton} />
                                </button>
                            </div>
                            <div className="login--form__row form__row">
                                <a href="#" className="login--form__btn login--form__btn__js" style={denialLinkStyle}
                                   onClick={this.props.denyConfirmationCallback}>
                                    <FormattedMessage {...messages.denial} />
                                </a>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect()(reduxForm({
    form: 'phone-input-form',
    fields,
    validate: phoneValidation
})(PhoneInput));



// WEBPACK FOOTER //
// ./js/shared/components/PhoneConfirmation/PhoneInput.jsx